export const queryKeys = {
  me: "me",
  getUsers: "getUsers",
  getLogins: "getLogins",
  getUserLogs: "getUserLogs",
  getLoginLogs: "getLoginLogs",
  getLinkGoogleAccount: "getLinkGoogleAccount",
  debugInfo: "debugInfo",
  getBetsSports: "getBetsSports",
};
